/**
 * Obsługa formularza opinii klientow na karcie produktow
 * @type {module}
 */
app.service('opinionForm',function(validate, loading, productCardConfig, modal, callback, front, log, captchaService, text) {
	var $self, $form, $starsForVoting, $yourGrade, $cancelOpinionButton, $summary, $attributeNotes, $opinionStars, $agreementForEmails;
	var starsRatingLength;

	function loadSuccess(html) {
		$self.html(html).removeClass('loading');
		setElements();
		setEvents();
		addOpinionCaptcha();
		starsRatingLength = $('.js-attribute-grade input').length;
		if(starsRatingLength === 0) {
			//jeśli brak ocen szczegolowych, waliduj tylko 1 element - ocene glowna
			starsRatingLength = 1;
			setMainStarEvent();
		}
		if ($summary.length) {
			$.scrollTo($summary);
		} else {
			setStars();
			setOpinionStars();
			parseBadWordsResponse();
			validate.task('opinion', {submit:checkAndSubmit,starLength:starsRatingLength});
		}
		loading.stop();
	}
	function loadError(){
		modal.alert('Wystąpił błąd ładowania formularza. Prosimy spróbować później');
	}
	function load() {
		var config=productCardConfig.getData();
		if(front.katalog){
			window.open(config.euroUrl+'#opinionForm');
		}else{
			$self.removeClass('add-opinion-form-hidden').addClass('loading');
			$.scrollTo($self);
			var data = {
				'product-link-name':config.linkName,
				preview:config.preview,
				mid: getUrlParameter('mid'),
				grade: getUrlParameter('grade'),
			};
			$.ajax({
				url:'/product-opinion-form.ltr',
				cache:false,
				data: data,
				success: function(html) {
					loadSuccess(html, true);
				},
				error:function(){
					loadError();
				}
			});
		}
	}
	function setStars(){
		var mainGrade=$('#grade').val();
		$('#stars-for-voting .grade-item').each(function(){
			var input=$(this).find('input');
			setActiveStar(input.val(),input.attr('id').substr(5),false);
		});
		setMainStar(mainGrade,true);
	}
	function setActiveStar(grade,id,summary){
		grade=Math.max(grade,0);
		$('#stars'+id+' a').removeClass('active');
		$('#stars'+id+' a:lt('+(grade)+')').addClass('active');
		if(summary){
			setMainOpinion();
		}
	}
	function setMainOpinion(){
		var grade=0;
		var attribute=0;
		$('#stars-for-voting input:hidden').each(function(){
			attribute=attribute+1;
			grade+=parseInt($(this).val());
		});
		setMainStar(Math.ceil(grade/attribute),true);
	}
	function setMainStar(grade,save){
		grade=Math.max(grade,0);
		if(save) {
			$('#grade').val(grade);
		}
		$('.js-your-grade a').removeClass('active');
		$('.js-your-grade a:lt('+(grade)+')').addClass('active');
	}
	function handlePromotionCheckboxes(isSelected){
		var $unchecked = $('input[type="checkbox"]', $opinionPromotionsTerms).not(':checked');
		var $parentRow = $unchecked.closest('.agreement-row');
		if(isSelected) {
			$unchecked.attr('disabled', 'true');
			$parentRow.addClass('show-promotion-hint');
		} else {
			$unchecked.removeAttr('disabled');
			$parentRow.removeClass('show-promotion-hint');
		}
	}
	function changeCheckboxValue(name){
		var element = $self.find('input[name="_' + name + '"]');
		if($(element).attr('value') === 'on') {
			$(element).attr('value', 'off');
		} else {
			$(element).attr('value', 'on');
		}
	}
	function addOpinionCaptcha() {
		let $captcha = $self.find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}
	function cancel(){
		$('#add-opinion-form').addClass('add-opinion-form-hidden');
	}
	function setEvents() {
		$starsForVoting.hover(function(){
			var rel=$(this).data('value').split('|');
			setActiveStar(rel[0],rel[1],true);
		},function(){
			var rel=$(this).data('value').split('|');
			setActiveStar($('#grade'+rel[1]).val()/1,rel[1],true);
		}).click(function(){
			var rel=$(this).data('value').split('|');
			$('#grade'+rel[1]).val(rel[0]);
			setActiveStar($('#grade' + rel[1]).val() / 1, rel[1], true);
			setOpinionStars();
		});
		$yourGrade.hover(function(){
			var rel=parseInt($(this).data('value'));
			setMainStar(rel,false);
		},function(){
			setMainStar(parseInt($('#grade').val()),false);
		}).click(function(){
			var rel=parseInt($(this).data('value'));
			setMainStar(rel,true);
		});
		$cancelOpinionButton.on('click', function(){
			cancel();
		});
		if($opinionPromotionsCheckboxes.length > 1 ){
			$opinionPromotionsCheckboxes.on('change', function(e){
				handlePromotionCheckboxes(e.target.checked);
			});
		}
		$agreementForEmails.on('change', function(){
			changeCheckboxValue($(this).attr('name'));
		});
	}
	function checkAndSubmit(){
		if(www.pageType=='account') {
			editSubmit();
		} else {
			callback.run('opinionLog', true);
			addSubmit();
		}
	}
	function editSubmit(){
		$('#add-opinion-form').ajaxSubmit({
			type: 'POST',
			url:'/product-opinion-form.ltr',
			data:{chandelier:parseInt(new Date().getTime()/649)},
			target:'#opinion-list',
			cache:false,
			success: function(html) {
			},
			error:function(){
				modal.alert('Wystąpił błąd zapisu Opini. Proszę spróbować później');
			}
		});
	}
	function addSubmit(){
		loading.start();
		var config = productCardConfig.getData();
		var data={
			'product-link-name':config.linkName,
			mid: getUrlParameter('mid'),
			chandelier:parseInt(new Date().getTime()/987),
			grade: getUrlParameter('grade')
		};
		$form.ajaxSubmit({
			beforeSubmit: function(payload) {
				const opinion = payload.find(el => el.name == 'opinion');
				opinion.value = text.clean(opinion.value);
			},
			url:'/product-opinion-form.ltr',
			type: 'POST',
			cache:false,
			data: data,
			success: function(html) {
				submitSuccess(html, config.plu);
			},
			error:function(){
				submitError();
			}
		});
	}
	function submitSuccess(html, productPlu) {
		var url = document.location.pathname + '?opinionAdd=OK';
		UA.pageview(url);
		log.recommendationsForAWS({
			productPlu,
			eventCategory: 'KP',
			eventAction: 'Opinie',
			eventLabel: 'Dodaj opinię'
		});
		loadSuccess(html);
	}
	function submitError(){
		modal.alert('Wystąpił błąd wysyłania formularza. Prosimy spróbować później');
	}
	function getUrlParameter(name) {
		name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
		var regexS = "[\\?&]" + name + "=([^&#]*)";
		var regex = new RegExp(regexS);
		var results = regex.exec(window.location.href);
		if (results === null){
			return "";
		}else{
			return results[1];
		}
	}
	function parseBadWordsResponse() {
		if($('#opinion').hasClass('js-contains-bad-words')) {
			$('#opinion').wysiwyg();
		}
	}
	function setOpinionStars(){
		var opinionStars = $('#opinion-stars');
		var valid = 0;
		if ($('#stars-for-voting').length) {
			$('#stars-for-voting input').each(function(){
				if($(this).val() > 0) {
					valid++;
				}
			});
			opinionStars.val(valid);
		}
		if (valid === $attributeNotes.length) {
			if ($opinionStars.hasClass('error')) {
				$form.validate().element($opinionStars);
			}
		}
	}
	function setMainStarEvent() {
		$yourGrade.on('click', function() {
			var mainGrade = $('#grade').val();
			$opinionStars.val(mainGrade);
			validateMainStars(mainGrade);
		});
	}
	function validateMainStars(mainGrade) {
		if (mainGrade > 0) {
			if ($opinionStars.hasClass('error')) {
				$form.validate().element($opinionStars);
			}
		}
	}
	function setElements(){
		$form = $('form', $self);
		$opinionStars = $('#opinion-stars', $self);
		$starsForVoting = $('.js-attribute-grade a', $self);
		$yourGrade = $('.js-your-grade a', $self);
		$cancelOpinionButton = $('.js-submit-opinion-cancel', $self);
		$summary = $('#opinion-summary', $self);
		$attributeNotes = $('#opinion-form-grades .js-attribute-grade input', $self);
		$opinionPromotionsTerms = $('#opinion-promotions-terms', $self);
		$opinionPromotionsCheckboxes = $('.checkbox-css', $opinionPromotionsTerms);
		$agreementForEmails = $('#agreement-for-emails', $self);
	}
	function init(){
		$self = $('#add-opinion-form');
		var hash = document.location.hash;
		if (hash == '#add-opinion-form' || hash == '#opinionForm' || hash == '#opinionFormAdd' || document.location.search.indexOf('mid=') > -1) {		//TODO po uwspolnieniu frontow będzie do skrocenia
			load();
		}
	}
	return {
		init:init,
		load:load
	};
});
